import React from "react";
import { Box, IconButton, Tooltip, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { renderIcon } from "../../../helpers/renderDynamicIcons";
/* function renderIcon(icon, extraProps) {
	if (!icon) return null;
	let reactElement =null
	if (React.isValidElement(icon)) {
		//console.log("icon is valid")
		reactElement = React.cloneElement(icon, { ...extraProps, ...(icon.props || {}) });
		return reactElement
	}
	reactElement = React.createElement(icon, extraProps);
	return reactElement
} */

export const TableActionButton = ({
	icon,
	onClick,
	tooltip,
	label, // alias for tooltip
	text, // new prop for button text
	color = "primary",
	size = "small",
	disabled = false,
	show = true,
	variant = "text", // new prop for Button variant
	...otherProps
}) => {
	const [t, i18n] = useTranslation();
	if (!show) return null;

	const title = t(tooltip ?? label ?? "");
	const buttonText = text ? t(text) : null;

	// If text is provided, render a regular Button
	if (buttonText) {
		return (
			<Tooltip title={title || ""} arrow>
				<span>
					<Button
						size={size}
						color={color}
						onClick={onClick}
						disabled={disabled}
						variant={variant}
						startIcon={icon ? renderIcon(icon, { fontSize: size === "small" ? "small" : "inherit" }) : null}
						{...otherProps}
					>
						{buttonText}
					</Button>
				</span>
			</Tooltip>
		);
	}

	// Otherwise, render IconButton as before
	return (
		<Tooltip title={title} arrow>
			<span>
				<IconButton size={size} color={color} onClick={onClick} disabled={disabled} {...otherProps}>
					{renderIcon(icon, { fontSize: size === "small" ? "small" : "inherit" })}
				</IconButton>
			</span>
		</Tooltip>
	);
};

export const TableActionGroup = ({ children, spacing = 1, direction = "row", align = "center", ...otherProps }) => (
	<Box
		sx={{
			display: "flex",
			gap: spacing,
			flexDirection: direction,
			alignItems: align,
		}}
		{...otherProps}
	>
		{children}
	</Box>
);

export const TableActionButtonWithLoading = ({ icon, loadingIcon, loading = false, tooltip, loadingTooltip, onClick, disabled = false, ...otherProps }) => (
	<TableActionButton
		icon={loading && loadingIcon ? loadingIcon : icon}
		tooltip={loading && loadingTooltip ? loadingTooltip : tooltip}
		onClick={onClick}
		disabled={disabled || loading}
		{...otherProps}
	/>
);

export const TableConfirmActionButton = ({ icon, tooltip, confirmMessage = "Are you sure?", onConfirm, ...otherProps }) => {
	const handleClick = () => {
		if (window.confirm(confirmMessage)) onConfirm?.();
	};

	return <TableActionButton icon={icon} tooltip={tooltip} onClick={handleClick} {...otherProps} />;
};
